<div style="display: flex; align-items: flex-start; gap: 15px; margin-left: 24px">
  <div class="info-title">{{ 'Settings.ConfigurationManager' | translate }}</div>
  <div (click)="showConfigs = !showConfigs" style="cursor: pointer">
    <mat-icon style="font-size: 24px" *ngIf="showConfigs">keyboard_arrow_up</mat-icon>
    <mat-icon style="font-size: 24px" *ngIf="!showConfigs">chevron_right</mat-icon>
  </div>
</div>

<div *ngIf="showConfigs" class="section-container box-shadow">
  <div class="info-title">{{ 'Settings.DeviceTestingMap' | translate }}</div>

  <div *ngFor="let receiver of companiesService.currentCompany?.receivers; let i = index">
    <div class="info-title">{{ receiver?.name }}</div>
    <div class="signals-section-row">
      <div>
        <app-input-number-customized
          [value]="receiver.testPHourConfiguration.lowControl"
          (valueChange)="onLowControlChange(receiver, $event)"
          [label]="'Settings.WeakSignal' | translate"
          [tooltip]="'Settings.WeakSignalTooltip' | translate"
          [step]="1"
          [min]="1"
          [max]="14"
          [disabled]="companiesService.loading"
          [pressIntervalMs]="150"
        >
        </app-input-number-customized>
        <mat-error
          class="phour-test-error-message"
          *ngIf="testPHourConfigurationLowControlError(receiver.testPHourConfiguration)"
          >{{ 'Settings.WeakSignalError' | translate }}</mat-error
        >
      </div>
      <div>
        <app-input-number-customized
          [value]="receiver.testPHourConfiguration.goodControl"
          (valueChange)="onGoodControlChange(receiver, $event)"
          [label]="'Settings.ExcellentSignal' | translate"
          [tooltip]="'Settings.ExcellentSignalTooltip' | translate"
          [step]="1"
          [min]="1"
          [max]="14"
          [disabled]="companiesService.loading"
          [pressIntervalMs]="150"
        >
        </app-input-number-customized>
        <mat-error
          class="phour-test-error-message"
          *ngIf="testPHourConfigurationGoodControlError(receiver.testPHourConfiguration)"
          >{{ 'Settings.ExcellentSignalError' | translate }}</mat-error
        >
      </div>
    </div>
  </div>

  <!-- RECEIVERS -->
  <div class="info-title">{{ 'Settings.AIKairon' | translate }}</div>
  <!-- At least one receiver -->
  <div *ngIf="companiesService.currentCompany?.receivers?.length > 0">
    <div class="config-section">
      <div class="config-item">
        <div class="config-toggle-container">
          <ui-switch
            [(ngModel)]="companiesService.currentCompany.kairon.isEnabled"
            (valueChange)="onKaironIsEnabledChange(companiesService.currentCompany, $event)"
          ></ui-switch>
          <span class="enabled-disabled-label">{{
            companiesService.currentCompany.kairon.isEnabled
              ? ('Settings.Enabled' | translate)
              : ('Settings.Disabled' | translate)
          }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="companiesService.currentCompany.kairon.isEnabled" style="margin-left: 20px">
      <!-- Corte de energía -->
      <div class="config-section">
        <h3 class="config-section-title">{{ 'Settings.PowerCut' | translate }}</h3>
        <div style="display: flex; gap: 80px; align-items: flex-end">
          <app-input-number-customized
            [value]="companiesService.currentCompany.kairon.eventDetectionConfig.radiusMeters"
            (valueChange)="onRadiusMetersChange(companiesService.currentCompany, $event)"
            [label]="'Settings.RegionDistance' | translate"
            [tooltip]="'Settings.RegionDistanceTooltip' | translate"
            [step]="100"
            [min]="100"
            [max]="100000"
            [disabled]="companiesService.loading"
            [pressIntervalMs]="150"
            unit="m"
          >
          </app-input-number-customized>

          <div class="config-item-input">
            <div class="config-input-container custom-mat-form-field">
              <div class="config-label-container" style="width: 200px">
                <label class="config-label">{{ 'Settings.CustomContactId' | translate }}</label>
              </div>

              <mat-form-field style="width: 120px" appearance="outline" class="config-input">
                <input
                  matInput
                  type="text"
                  name="customContactId"
                  required
                  maxlength="5"
                  pattern="^[A-Za-z0-9]{1,5}$"
                  [(ngModel)]="companiesService.currentCompany.kairon.eventDetectionConfig.eventCID"
                  #inputNumber="ngModel"
                  (input)="onCidInput($event)"
                  autocapitalize="characters"
                  autocomplete="off"
                />
              </mat-form-field>

              <a
                href="https://www.voip-sip-sdk.com/attachments/583/contact_id.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <mat-icon class="info-icon" matTooltip="{{ 'Settings.CustomContactIdToolTip' | translate }}">
                  info
                </mat-icon>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Programación de armado y desarmado -->
      <div class="config-section">
        <h3 class="config-section-title">{{ 'Settings.ControlSchedule' | translate }}</h3>

        <div style="display: flex; gap: 80px; align-items: flex-end">
          <app-input-number-customized
            [value]="companiesService.currentCompany.kairon.reminderConfig.toleranceMinutes"
            (valueChange)="onToleranceMinutesChange(companiesService.currentCompany, $event)"
            [label]="'Settings.ToleranceTime' | translate"
            [tooltip]="'Settings.ToleranceTimeTooltip' | translate"
            [step]="1"
            [min]="1"
            [max]="3600"
            [disabled]="companiesService.loading"
            [pressIntervalMs]="150"
            unit="min"
          >
          </app-input-number-customized>

          <app-input-number-customized
            [value]="companiesService.currentCompany.kairon.reminderConfig.retryMinutes"
            (valueChange)="onRetryMinutesChange(companiesService.currentCompany, $event)"
            [label]="'Settings.ReminderTime' | translate"
            [tooltip]="'Settings.ReminderTimeTooltip' | translate"
            [step]="5"
            [min]="5"
            [max]="3600"
            [pressIntervalMs]="150"
            [disabled]="companiesService.loading"
            unit="min"
          >
          </app-input-number-customized>
        </div>
      </div>
    </div>
  </div>

  <div class="voice-section-header" *ngIf="authService.hasRoleAdmin()">
    <div class="voice-title-row">
      <div class="info-title voice-section-title">{{ 'Settings.AIKaironVoice' | translate }}</div>
      <button
        *ngIf="simulationCompanyId && authService.hasRoleAdmin() && companiesService.currentCompany?._id === simulationCompanyId"
        mat-raised-button
        id="btn-voice-simulate"
        (click)="openVoiceSimulationDialog()"
        style="background-color: #FFCC00; color: #000; font-weight: 600; min-height: 36px; font-size: 13px;"
      >
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">phone_in_talk</mat-icon>
        {{ 'Settings.VoiceSimulateButton' | translate }}
      </button>
    </div>

    <div *ngIf="companiesService.currentCompany?.receivers?.length > 0 && ensureVoiceConfig()" class="voice-toggle-row">
      <div class="config-toggle-container">
        <ui-switch
          [(ngModel)]="companiesService.currentCompany.kairon.voice.isEnabled"
          (valueChange)="onKaironVoiceIsEnabledChange(companiesService.currentCompany, $event)"
        ></ui-switch>
        <span class="enabled-disabled-label">{{
          companiesService.currentCompany.kairon.voice.isEnabled
            ? ('Settings.Enabled' | translate)
            : ('Settings.Disabled' | translate)
        }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="authService.hasRoleAdmin() && companiesService.currentCompany.kairon.voice.isEnabled" style="margin-left: 20px">
      <div class="config-section" *ngIf="authService.hasRoleAdmin()">
        <h3 class="config-section-title">{{ 'Settings.VoiceCallRetries' | translate }}</h3>
        <app-input-number-customized
          [value]="companiesService.currentCompany.kairon.voice.callRetryLimit"
          (valueChange)="onCallRetryLimitChange(companiesService.currentCompany, $event)"
          [label]="'Settings.VoiceCallRetries' | translate"
          [tooltip]="'Settings.VoiceCallRetriesTooltip' | translate"
          [step]="1"
          [min]="1"
          [max]="5"
          [disabled]="companiesService.loading"
          [pressIntervalMs]="150"
        >
        </app-input-number-customized>
      </div>

      <div class="config-section">
        <h3 class="config-section-title">{{ 'Settings.VoiceCIDMapping' | translate }}</h3>
        <div style="display: flex; gap: 40px; align-items: flex-end; flex-wrap: wrap">

          <div class="config-item-input">
            <div class="config-input-container custom-mat-form-field">
              <div class="config-label-container" style="width: 160px">
                <label class="config-label">{{ 'Settings.VoiceCIDFalseAlarm' | translate }}</label>
              </div>
              <mat-form-field style="width: 120px" appearance="outline" class="config-input">
                <input
                  matInput
                  type="text"
                  name="cidFalseAlarm"
                  required
                  maxlength="4"
                  #cidFalseAlarmInput="ngModel"
                  [(ngModel)]="companiesService.currentCompany.kairon.voice.cidFalseAlarm"
                  (input)="onVoiceCidInput($event, 'cidFalseAlarm')"
                  autocomplete="off"
                />
                <mat-error *ngIf="cidFalseAlarmInput.invalid && cidFalseAlarmInput.touched">
                  {{ 'Settings.VoiceCIDRequired' | translate }}
                </mat-error>
              </mat-form-field>
              <a href="https://www.voip-sip-sdk.com/attachments/583/contact_id.pdf" target="_blank" rel="noopener noreferrer">
                <mat-icon class="info-icon" matTooltip="{{ 'Settings.CustomContactIdToolTip' | translate }}">info</mat-icon>
              </a>
            </div>
          </div>

          <div class="config-item-input">
            <div class="config-input-container custom-mat-form-field">
              <div class="config-label-container" style="width: 160px">
                <label class="config-label">{{ 'Settings.VoiceCIDDuress' | translate }}</label>
              </div>
              <mat-form-field style="width: 120px" appearance="outline" class="config-input">
                <input
                  matInput
                  type="text"
                  name="cidDuress"
                  required
                  maxlength="4"
                  #cidDuressInput="ngModel"
                  [(ngModel)]="companiesService.currentCompany.kairon.voice.cidDuress"
                  (input)="onVoiceCidInput($event, 'cidDuress')"
                  autocomplete="off"
                />
                <mat-error *ngIf="cidDuressInput.invalid && cidDuressInput.touched">
                  {{ 'Settings.VoiceCIDRequired' | translate }}
                </mat-error>
              </mat-form-field>
              <a href="https://www.voip-sip-sdk.com/attachments/583/contact_id.pdf" target="_blank" rel="noopener noreferrer">
                <mat-icon class="info-icon" matTooltip="{{ 'Settings.CustomContactIdToolTip' | translate }}">info</mat-icon>
              </a>
            </div>
          </div>

          <div class="config-item-input">
            <div class="config-input-container custom-mat-form-field">
              <div class="config-label-container" style="width: 160px">
                <label class="config-label">{{ 'Settings.VoiceCIDNoContact' | translate }}</label>
              </div>
              <mat-form-field style="width: 120px" appearance="outline" class="config-input">
                <input
                  matInput
                  type="text"
                  name="cidNoContact"
                  required
                  maxlength="4"
                  #cidNoContactInput="ngModel"
                  [(ngModel)]="companiesService.currentCompany.kairon.voice.cidNoContact"
                  (input)="onVoiceCidInput($event, 'cidNoContact')"
                  autocomplete="off"
                />
                <mat-error *ngIf="cidNoContactInput.invalid && cidNoContactInput.touched">
                  {{ 'Settings.VoiceCIDRequired' | translate }}
                </mat-error>
              </mat-form-field>
              <a href="https://www.voip-sip-sdk.com/attachments/583/contact_id.pdf" target="_blank" rel="noopener noreferrer">
                <mat-icon class="info-icon" matTooltip="{{ 'Settings.CustomContactIdToolTip' | translate }}">info</mat-icon>
              </a>
            </div>
          </div>

          <div class="config-item-input">
            <div class="config-input-container custom-mat-form-field">
              <div class="config-label-container" style="width: 160px">
                <label class="config-label">{{ 'Settings.VoiceCIDCommFailure' | translate }}</label>
              </div>
              <mat-form-field style="width: 120px" appearance="outline" class="config-input">
                <input
                  matInput
                  type="text"
                  name="cidCommFailure"
                  required
                  maxlength="4"
                  #cidCommFailureInput="ngModel"
                  [(ngModel)]="companiesService.currentCompany.kairon.voice.cidCommFailure"
                  (input)="onVoiceCidInput($event, 'cidCommFailure')"
                  autocomplete="off"
                />
                <mat-error *ngIf="cidCommFailureInput.invalid && cidCommFailureInput.touched">
                  {{ 'Settings.VoiceCIDRequired' | translate }}
                </mat-error>
              </mat-form-field>
              <a href="https://www.voip-sip-sdk.com/attachments/583/contact_id.pdf" target="_blank" rel="noopener noreferrer">
                <mat-icon class="info-icon" matTooltip="{{ 'Settings.CustomContactIdToolTip' | translate }}">info</mat-icon>
              </a>
            </div>
          </div>

        </div>
      </div>
  </div>

  <div class="info-title">{{ 'Settings.AIMaia' | translate }}</div>
  <!-- At least one receiver -->
  <div *ngIf="companiesService.currentCompany?.receivers?.length > 0">
    <div class="config-section">
      <div class="config-item">
        <div class="config-toggle-container">
          <ui-switch
            [(ngModel)]="companiesService.currentCompany.maia.isEnabled"
            (valueChange)="onMaiaIsEnabledChange(companiesService.currentCompany, $event)"
          ></ui-switch>
          <span class="enabled-disabled-label">{{
            companiesService.currentCompany.maia.isEnabled
              ? ('Settings.Enabled' | translate)
              : ('Settings.Disabled' | translate)
          }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="companiesService.currentCompany.maia?.isEnabled" style="margin-left: 20px; margin-top: 20px">
      <!-- Maia Alarm Event -->
      <div class="config-section">
        <h3 class="config-section-title">{{ 'Settings.AlertEventSend' | translate }}</h3>
        <div style="display: flex; gap: 160px; align-items: flex-end">
          <app-input-date-customized
            [label]="'Settings.PerimetralArmPeriod' | translate"
            [value]="companiesService.currentCompany.maia.perimetralConfig.startHour"
            (valueChange)="onAlarmEventSendChange(companiesService.currentCompany, 'startHour', $event)"
            [step]="10"
            [fieldName]="'startHour'"
            class="input-date-customized"
          ></app-input-date-customized>
          <app-input-date-customized
            [label]="'Settings.PerimetralArmPeriodEnd' | translate"
            [tooltip]="'Settings.AlertEventSendTooltip' | translate"
            [value]="companiesService.currentCompany.maia.perimetralConfig.endHour"
            (valueChange)="onAlarmEventSendChange(companiesService.currentCompany, 'endHour', $event)"
            [step]="10"
            [fieldName]="'endHour'"
            class="input-date-customized"
          ></app-input-date-customized>
        </div>
      </div>
    </div>
  </div>
</div>
